module.exports = __webpack_public_path__ + "static/image/default_image.79a8accb7803a5947b84eedf8ebef3d2.png";